module.exports = __webpack_public_path__ + "resources/icon_28_applaud_active.ae19b65bc10cf1c7.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_applaud_active.png
// module id = 421
// module chunks = 0 1 2 3 4